import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=9ab23b62"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=9ab23b62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports